import Vue from 'vue'

export default {
  state: {
    // actions is an ordered list of actions
    actions: [],
    action_errors: {},
    event_ids: [],
    filter: {},
    data: {},
  },
  mutations: {
    CLEAR_ERRORS (state) {
      state.action_errors = {}
    },
    SET_ERRORS (state, errors) {
      state.action_errors = {}

      Object.keys(errors).forEach((error) => {
        let message = errors[error]
        let splitted = error.split('.')
        if (splitted[0] === 'actions') {
          if (typeof state.action_errors[splitted[1]] === 'undefined') {
            Vue.set(state.action_errors, splitted[1], {})
          }
          Vue.set(state.action_errors[splitted[1]], splitted[2], message.join(' '))
        }
      })
    },
    STORE_DATA (state, data) {
      state.data = data // set start/enddata program and name
    },
    STORE_FILTER (state, filter) {
      state.filter = filter
    },
    STORE_EVENTS (state, event_ids) {
      state.event_ids = event_ids
    },
    // (un) subscriptions
    ADD_ACTION (state, field) {
      state.actions.push({
        field: field,
        type: '',
        value: '',
        sub_field: field, // this is probably wrong
        sub_type: '',
        // todo add the other update_rule attributes
      })
    },
    UPDATE_ACTION_TYPE (state, { index, value }) {
      state.actions[index].type = value
    },
    UPDATE_ACTION_VALUE (state, { index, value }) {
      state.actions[index].value = value
    },

    UPDATE_ACTION (state, { index, name, value }) {
      state.actions[index][name] = value
    },

    REMOVE_ACTION (state, index) {
      state.actions.splice(index, 1)
    },
  },
  actions: {
    clear_errors ({ commit, state }) {
      commit('CLEAR_ERRORS')
    },
    set_errors ({ commit, state }, errors) {
      commit('SET_ERRORS', errors)
    },
    store_data ({ commit, state }, data) {
      commit('STORE_DATA', data)
    },
    store_filter ({ commit, state }, filter) {
      commit('STORE_FILTER', filter)
    },
    store_events ({ commit, state }, event_ids) {
      commit('STORE_EVENTS', event_ids)
    },
    add_action ({ commit, state }, { field }) {
      commit('ADD_ACTION', field)
    },
    update_action_type ({ commit, state }, { index, value }) {
      commit('UPDATE_ACTION_TYPE', { index, value })
    },
    update_action_value ({ commit, state }, { index, value }) {
      commit('UPDATE_ACTION_VALUE', { index, value })
    },
    update_action ({ commit, state }, { index, name, value }) {
      commit('UPDATE_ACTION', { index, name, value })
    },

    remove_action ({ commit, state }, index) {
      commit('REMOVE_ACTION', index)
    },
  },
  getters: {
    /**
     * check if all actions are filled, so we dont have to validate them using a request to the backend
     * @returns {boolean}
     */
    actionsFilled (state) {
      let isRelation = (field) => {
        let relations = ['groups', 'lecturers', 'classrooms']

        return relations.includes(field)
      }
      return state.actions.every((action) => {
        if (isRelation(action.field)) {
          return action.type !== '' && action.sub_type !== '' && action.sub_field !== ''
        }
        return action.type !== ''
      })
    },
    startdate (state) {
      return state.data.startdate
    },
    enddate (state) {
      return state.data.enddate
    },
    filterJSON (state) {
      return JSON.stringify(state.filter)
    },
    /**
     * computes the json of all actions to preview and to send to the server
     * @returns {any}
     */
    actionObj (state) {
      let obj = state.actions.map((action, index) => {
        // todo retrieve the other values from the vuex store ( or all values? )
        return {
          order: index,
          type: action.type,
          field: action.field,
          update_rule: {
            value: action.value,
            type: action.sub_type,
            field: action.sub_field,
          },
        }
      })
      return obj
    },
    /**
     * Format to json-string, useful for displaying the 'technical view'
     * @param state
     * @param getters
     */
    actionJSON (state, getters) {
      return JSON.stringify(getters.actionObj, null, 4)
    },
  },
}
